import SuccessAlert from "./SuccessAlert";
import ErrorAlert from "./ErrorAlert";
import InfoAlert from "./InfoAlert";
import InlineAlert from "./InlineAlert";
import WarnAlert from "./WarnAlert";
import Alert from "./Alert";

export default Alert;
export { SuccessAlert, ErrorAlert, InfoAlert, InlineAlert, WarnAlert };
